function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25 5v20H5V5z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M23 7H7v16h16z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17 18v2h-7v-2h7zm3-4v2H10v-2h10zm0-4v2H10v-2h10z"
});

function SvgQOpenResponseTypeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _ref, _ref2, _ref3);
}

export default SvgQOpenResponseTypeIcon;